'use client'

import type { ReactNode } from 'react'
import {
  SharedSurfaceProvider,
  type SharedSkin,
  type SharedSurface,
} from '@/deskUiSkeletons/Shared/SharedSurfaceContext'
import { MsgDeskLoading } from '../MsgDeskLoading'

const wikiSharedSkin: SharedSkin = {
  navItem: 'group relative flex h-9 cursor-pointer items-center rounded px-3 text-sm text-slate-700 hover:bg-slate-100',
  navItemSelected: 'bg-slate-100 font-semibold text-slate-950',
  navLabel: 'flex items-center',
  navLoading: 'animate-pulse',
  moreLink: 'mt-3 inline-flex w-max cursor-pointer text-sm font-medium text-blue-700 hover:underline',
  testBadge: 'fixed right-2 top-14 z-[100000] rounded bg-red-600 px-2 py-1 text-[10px] font-bold text-white',
  testBadgeInfo: 'hidden',
  dialogBackdrop: 'hidden',
  dialogWindow: 'hidden',
  savingBackdrop: 'fixed inset-0 z-[100001] hidden bg-slate-950/25',
  savingContent: 'fixed left-1/2 top-1/2 z-[100002] hidden -translate-x-1/2 -translate-y-1/2',
  msgBoxOverlay: 'fixed inset-0 z-[100003] hidden bg-white/70 text-center text-slate-900',
  msgBoxSpacer: 'h-[40%]',
  msgBox: 'inline-flex max-w-full flex-col overflow-hidden rounded border border-slate-200 bg-white shadow-xl',
  msgBoxInfo: 'flex flex-col items-center p-4',
  msgBoxText: 'my-2',
  msgBoxPin: 'hidden',
  msgBoxCaptchaImg: 'block h-auto w-auto',
  msgBoxButtons: 'flex justify-center gap-2 border-t border-slate-200 bg-slate-50 p-2',
  msgBoxClose: 'cursor-pointer px-3 py-1 text-blue-700',
  msgBoxHiddenCancel: 'hidden',
  qrOverlay: 'fixed inset-0 z-[100000] flex items-center justify-center bg-slate-950/30 p-4',
  qrInline: 'mx-2 my-2 w-full max-w-[640px]',
  qrRoot: 'w-[min(640px,calc(100vw-32px))]',
  qrForm: 'block min-h-[180px] rounded bg-white p-3 text-slate-900 shadow-xl',
  qrEditForm: 'w-full',
  qrTextarea: 'block h-[130px] w-full rounded border border-slate-300 bg-white p-2 text-sm',
  qrEmailLabel: 'block text-xs',
  qrCheckbox: 'mr-2',
  qrEmailLink: 'text-xs text-blue-700',
  qrEmailValue: 'underline',
  qrActions: 'flex justify-end gap-2',
  qrSaveButton: 'rounded bg-blue-700 px-3 py-1.5 text-xs font-semibold text-white',
  qrShadowRight: 'hidden',
  qrShadowBottom: 'hidden',
  pinOverlay: 'fixed inset-0 z-[100004] flex items-center justify-center bg-white/75 p-5 text-xs text-slate-900 backdrop-blur-sm',
  pinBox: 'flex w-[300px] max-w-full flex-col rounded border border-slate-200 bg-white shadow-2xl',
  pinMessage: 'px-4 pb-2 pt-4 text-center font-semibold',
  pinInput: 'mx-4 mb-3 rounded border border-slate-300 bg-white p-2 text-sm outline-none focus:border-blue-600',
  pinActions: 'flex justify-end gap-2 border-t border-slate-200 bg-slate-50 p-3',
  pinButton: 'rounded px-3 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-200',
  pinButtonPrimary: 'rounded bg-blue-700 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-800',
}

const wikiSharedSurface: SharedSurface = {
  Loading: MsgDeskLoading,
  skin: wikiSharedSkin,
}

export function WikiSharedSurfaceProvider({ children }: { children: ReactNode }) {
  return <SharedSurfaceProvider value={wikiSharedSurface}>{children}</SharedSurfaceProvider>
}
